import CustomerOrderCreatedPage from "./CustomerOrderCreatedPage.vue";

export {CustomerOrderCreatedPage}
export default CustomerOrderCreatedPage
